import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import { RouteModule } from '#/horizon/components/RouteModule';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { redirectRequireAuthentication } from '#/modules/auth/routing/redirect-require-authentication';
import { listingApiIsomorphicFetchRsvps } from '#/modules/listing/events/api/listingApiFetchRsvps';
import { userDashboardApiIsomorphicFetchEvent } from '#/modules/userDashboard/api/userDashboardApiFetchEvent';
import { UserDashboardViewEventPageLoadable } from '#/modules/userDashboard/pages/ViewEvent/UserDashboardViewEventPageLoadable';
import { userDashboardViewEventRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

export const handle = {
  darkBackground: true,
  fallbackUrlByLocaleToCurrent: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { eventId },
}: HorizonAppRouteLoaderArgs<typeof userDashboardViewEventRoute>) {
  const [{ user }, event, rsvps] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    userDashboardApiIsomorphicFetchEvent({ request, context })(eventId),
    listingApiIsomorphicFetchRsvps({ request, context })(eventId).catch(
      () => [],
    ),
    UserDashboardViewEventPageLoadable.load(),
  ]);

  if (!user) return redirectRequireAuthentication({ request });

  return { event, rsvps };
}

export default function UserDashboardViewEventHorizonRoute({
  loaderData: { event, rsvps },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return (
    <RouteModule title={event.name}>
      <UserDashboardViewEventPageLoadable initialEvent={event} rsvps={rsvps} />
    </RouteModule>
  );
}
